/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type * as Types from './schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export * from './schema.js';
const defaultOptions = {} as const;
export type FindManyAttributeLocalesQueryVariables = Exact<{
  input?: Types.FindManyAttributeLocalesInput | null | undefined;
}>;


export type FindManyAttributeLocalesQuery = { findManyAttributeLocales: { edges: Array<{ node: { label: string, description: string, locale: string, attribute: { uuid: string } } }>, pageInfo: { hasNextPage: boolean, endCursor: string } } };

export type FindManyCredentialLocalesQueryVariables = Exact<{
  input?: Types.FindManyCredentialLocalesInput | null | undefined;
}>;


export type FindManyCredentialLocalesQuery = { findManyCredentialLocales: { edges: Array<{ node: { name: string, description: string, logo: string, locale: string, credential: { uuid: string } } }>, pageInfo: { hasNextPage: boolean, endCursor: string } } };

export type FindManyHandlerAppsQueryVariables = Exact<{
  input?: Types.FindManyHandlerAppsInput | null | undefined;
}>;


export type FindManyHandlerAppsQuery = { findManyHandlerApps: { edges: Array<{ node: { uuid: string, app: { name: string, base64Logo: string, countries: Array<string>, locales: { edges: Array<{ node: { locale: string, name: string, nameWithArticle: string } }> } } } }> } };

export type FindManyIssuerLocalesQueryVariables = Exact<{
  input?: Types.FindManyIssuerLocalesInput | null | undefined;
}>;


export type FindManyIssuerLocalesQuery = { findManyIssuerLocales: { edges: Array<{ node: { name: string, description: string, locale: string, issuer: { uuid: string } } }>, pageInfo: { hasNextPage: boolean, endCursor: string } } };

export type FindManyIssuersQueryVariables = Exact<{
  input?: Types.FindManyIssuersInput | null | undefined;
}>;


export type FindManyIssuersQuery = { findManyIssuers: { edges: Array<{ node: { uuid: string, base64Logo: string } }> } };

export type FindManyTrustLocalesQueryVariables = Exact<{
  input?: Types.FindManyTrustLocalesInput | null | undefined;
}>;


export type FindManyTrustLocalesQuery = { findManyTrustLocales: { edges: Array<{ node: { name: string, description: string, locale: string, trust: { uuid: string } } }>, pageInfo: { hasNextPage: boolean, endCursor: string } } };


export const FindManyAttributeLocalesDocument = gql`
    query FindManyAttributeLocales($input: FindManyAttributeLocalesInput) {
  findManyAttributeLocales(input: $input) {
    edges {
      node {
        attribute {
          uuid
        }
        label
        description
        locale
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;
export function useFindManyAttributeLocalesQuery(baseOptions?: Apollo.QueryHookOptions<FindManyAttributeLocalesQuery, FindManyAttributeLocalesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindManyAttributeLocalesQuery, FindManyAttributeLocalesQueryVariables>(FindManyAttributeLocalesDocument, options);
      }
export function useFindManyAttributeLocalesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindManyAttributeLocalesQuery, FindManyAttributeLocalesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindManyAttributeLocalesQuery, FindManyAttributeLocalesQueryVariables>(FindManyAttributeLocalesDocument, options);
        }
// @ts-ignore
export function useFindManyAttributeLocalesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindManyAttributeLocalesQuery, FindManyAttributeLocalesQueryVariables>): Apollo.UseSuspenseQueryResult<FindManyAttributeLocalesQuery, FindManyAttributeLocalesQueryVariables>;
export function useFindManyAttributeLocalesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindManyAttributeLocalesQuery, FindManyAttributeLocalesQueryVariables>): Apollo.UseSuspenseQueryResult<FindManyAttributeLocalesQuery | undefined, FindManyAttributeLocalesQueryVariables>;
export function useFindManyAttributeLocalesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindManyAttributeLocalesQuery, FindManyAttributeLocalesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindManyAttributeLocalesQuery, FindManyAttributeLocalesQueryVariables>(FindManyAttributeLocalesDocument, options);
        }
export type FindManyAttributeLocalesQueryHookResult = ReturnType<typeof useFindManyAttributeLocalesQuery>;
export type FindManyAttributeLocalesLazyQueryHookResult = ReturnType<typeof useFindManyAttributeLocalesLazyQuery>;
export type FindManyAttributeLocalesSuspenseQueryHookResult = ReturnType<typeof useFindManyAttributeLocalesSuspenseQuery>;
export type FindManyAttributeLocalesQueryResult = Apollo.QueryResult<FindManyAttributeLocalesQuery, FindManyAttributeLocalesQueryVariables>;
export const FindManyCredentialLocalesDocument = gql`
    query FindManyCredentialLocales($input: FindManyCredentialLocalesInput) {
  findManyCredentialLocales(input: $input) {
    edges {
      node {
        credential {
          uuid
        }
        name
        description
        logo
        locale
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;
export function useFindManyCredentialLocalesQuery(baseOptions?: Apollo.QueryHookOptions<FindManyCredentialLocalesQuery, FindManyCredentialLocalesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindManyCredentialLocalesQuery, FindManyCredentialLocalesQueryVariables>(FindManyCredentialLocalesDocument, options);
      }
export function useFindManyCredentialLocalesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindManyCredentialLocalesQuery, FindManyCredentialLocalesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindManyCredentialLocalesQuery, FindManyCredentialLocalesQueryVariables>(FindManyCredentialLocalesDocument, options);
        }
// @ts-ignore
export function useFindManyCredentialLocalesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindManyCredentialLocalesQuery, FindManyCredentialLocalesQueryVariables>): Apollo.UseSuspenseQueryResult<FindManyCredentialLocalesQuery, FindManyCredentialLocalesQueryVariables>;
export function useFindManyCredentialLocalesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindManyCredentialLocalesQuery, FindManyCredentialLocalesQueryVariables>): Apollo.UseSuspenseQueryResult<FindManyCredentialLocalesQuery | undefined, FindManyCredentialLocalesQueryVariables>;
export function useFindManyCredentialLocalesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindManyCredentialLocalesQuery, FindManyCredentialLocalesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindManyCredentialLocalesQuery, FindManyCredentialLocalesQueryVariables>(FindManyCredentialLocalesDocument, options);
        }
export type FindManyCredentialLocalesQueryHookResult = ReturnType<typeof useFindManyCredentialLocalesQuery>;
export type FindManyCredentialLocalesLazyQueryHookResult = ReturnType<typeof useFindManyCredentialLocalesLazyQuery>;
export type FindManyCredentialLocalesSuspenseQueryHookResult = ReturnType<typeof useFindManyCredentialLocalesSuspenseQuery>;
export type FindManyCredentialLocalesQueryResult = Apollo.QueryResult<FindManyCredentialLocalesQuery, FindManyCredentialLocalesQueryVariables>;
export const FindManyHandlerAppsDocument = gql`
    query FindManyHandlerApps($input: FindManyHandlerAppsInput) {
  findManyHandlerApps(input: $input) {
    edges {
      node {
        uuid
        app {
          name
          base64Logo
          countries
          locales(input: {pagination: {first: 50}}) {
            edges {
              node {
                locale
                name
                nameWithArticle
              }
            }
          }
        }
      }
    }
  }
}
    `;
export function useFindManyHandlerAppsQuery(baseOptions?: Apollo.QueryHookOptions<FindManyHandlerAppsQuery, FindManyHandlerAppsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindManyHandlerAppsQuery, FindManyHandlerAppsQueryVariables>(FindManyHandlerAppsDocument, options);
      }
export function useFindManyHandlerAppsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindManyHandlerAppsQuery, FindManyHandlerAppsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindManyHandlerAppsQuery, FindManyHandlerAppsQueryVariables>(FindManyHandlerAppsDocument, options);
        }
// @ts-ignore
export function useFindManyHandlerAppsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindManyHandlerAppsQuery, FindManyHandlerAppsQueryVariables>): Apollo.UseSuspenseQueryResult<FindManyHandlerAppsQuery, FindManyHandlerAppsQueryVariables>;
export function useFindManyHandlerAppsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindManyHandlerAppsQuery, FindManyHandlerAppsQueryVariables>): Apollo.UseSuspenseQueryResult<FindManyHandlerAppsQuery | undefined, FindManyHandlerAppsQueryVariables>;
export function useFindManyHandlerAppsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindManyHandlerAppsQuery, FindManyHandlerAppsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindManyHandlerAppsQuery, FindManyHandlerAppsQueryVariables>(FindManyHandlerAppsDocument, options);
        }
export type FindManyHandlerAppsQueryHookResult = ReturnType<typeof useFindManyHandlerAppsQuery>;
export type FindManyHandlerAppsLazyQueryHookResult = ReturnType<typeof useFindManyHandlerAppsLazyQuery>;
export type FindManyHandlerAppsSuspenseQueryHookResult = ReturnType<typeof useFindManyHandlerAppsSuspenseQuery>;
export type FindManyHandlerAppsQueryResult = Apollo.QueryResult<FindManyHandlerAppsQuery, FindManyHandlerAppsQueryVariables>;
export const FindManyIssuerLocalesDocument = gql`
    query FindManyIssuerLocales($input: FindManyIssuerLocalesInput) {
  findManyIssuerLocales(input: $input) {
    edges {
      node {
        issuer {
          uuid
        }
        name
        description
        locale
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;
export function useFindManyIssuerLocalesQuery(baseOptions?: Apollo.QueryHookOptions<FindManyIssuerLocalesQuery, FindManyIssuerLocalesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindManyIssuerLocalesQuery, FindManyIssuerLocalesQueryVariables>(FindManyIssuerLocalesDocument, options);
      }
export function useFindManyIssuerLocalesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindManyIssuerLocalesQuery, FindManyIssuerLocalesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindManyIssuerLocalesQuery, FindManyIssuerLocalesQueryVariables>(FindManyIssuerLocalesDocument, options);
        }
// @ts-ignore
export function useFindManyIssuerLocalesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindManyIssuerLocalesQuery, FindManyIssuerLocalesQueryVariables>): Apollo.UseSuspenseQueryResult<FindManyIssuerLocalesQuery, FindManyIssuerLocalesQueryVariables>;
export function useFindManyIssuerLocalesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindManyIssuerLocalesQuery, FindManyIssuerLocalesQueryVariables>): Apollo.UseSuspenseQueryResult<FindManyIssuerLocalesQuery | undefined, FindManyIssuerLocalesQueryVariables>;
export function useFindManyIssuerLocalesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindManyIssuerLocalesQuery, FindManyIssuerLocalesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindManyIssuerLocalesQuery, FindManyIssuerLocalesQueryVariables>(FindManyIssuerLocalesDocument, options);
        }
export type FindManyIssuerLocalesQueryHookResult = ReturnType<typeof useFindManyIssuerLocalesQuery>;
export type FindManyIssuerLocalesLazyQueryHookResult = ReturnType<typeof useFindManyIssuerLocalesLazyQuery>;
export type FindManyIssuerLocalesSuspenseQueryHookResult = ReturnType<typeof useFindManyIssuerLocalesSuspenseQuery>;
export type FindManyIssuerLocalesQueryResult = Apollo.QueryResult<FindManyIssuerLocalesQuery, FindManyIssuerLocalesQueryVariables>;
export const FindManyIssuersDocument = gql`
    query FindManyIssuers($input: FindManyIssuersInput) {
  findManyIssuers(input: $input) {
    edges {
      node {
        uuid
        base64Logo
      }
    }
  }
}
    `;
export function useFindManyIssuersQuery(baseOptions?: Apollo.QueryHookOptions<FindManyIssuersQuery, FindManyIssuersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindManyIssuersQuery, FindManyIssuersQueryVariables>(FindManyIssuersDocument, options);
      }
export function useFindManyIssuersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindManyIssuersQuery, FindManyIssuersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindManyIssuersQuery, FindManyIssuersQueryVariables>(FindManyIssuersDocument, options);
        }
// @ts-ignore
export function useFindManyIssuersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindManyIssuersQuery, FindManyIssuersQueryVariables>): Apollo.UseSuspenseQueryResult<FindManyIssuersQuery, FindManyIssuersQueryVariables>;
export function useFindManyIssuersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindManyIssuersQuery, FindManyIssuersQueryVariables>): Apollo.UseSuspenseQueryResult<FindManyIssuersQuery | undefined, FindManyIssuersQueryVariables>;
export function useFindManyIssuersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindManyIssuersQuery, FindManyIssuersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindManyIssuersQuery, FindManyIssuersQueryVariables>(FindManyIssuersDocument, options);
        }
export type FindManyIssuersQueryHookResult = ReturnType<typeof useFindManyIssuersQuery>;
export type FindManyIssuersLazyQueryHookResult = ReturnType<typeof useFindManyIssuersLazyQuery>;
export type FindManyIssuersSuspenseQueryHookResult = ReturnType<typeof useFindManyIssuersSuspenseQuery>;
export type FindManyIssuersQueryResult = Apollo.QueryResult<FindManyIssuersQuery, FindManyIssuersQueryVariables>;
export const FindManyTrustLocalesDocument = gql`
    query FindManyTrustLocales($input: FindManyTrustLocalesInput) {
  findManyTrustLocales(input: $input) {
    edges {
      node {
        trust {
          uuid
        }
        name
        description
        locale
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;
export function useFindManyTrustLocalesQuery(baseOptions?: Apollo.QueryHookOptions<FindManyTrustLocalesQuery, FindManyTrustLocalesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindManyTrustLocalesQuery, FindManyTrustLocalesQueryVariables>(FindManyTrustLocalesDocument, options);
      }
export function useFindManyTrustLocalesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindManyTrustLocalesQuery, FindManyTrustLocalesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindManyTrustLocalesQuery, FindManyTrustLocalesQueryVariables>(FindManyTrustLocalesDocument, options);
        }
// @ts-ignore
export function useFindManyTrustLocalesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindManyTrustLocalesQuery, FindManyTrustLocalesQueryVariables>): Apollo.UseSuspenseQueryResult<FindManyTrustLocalesQuery, FindManyTrustLocalesQueryVariables>;
export function useFindManyTrustLocalesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindManyTrustLocalesQuery, FindManyTrustLocalesQueryVariables>): Apollo.UseSuspenseQueryResult<FindManyTrustLocalesQuery | undefined, FindManyTrustLocalesQueryVariables>;
export function useFindManyTrustLocalesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindManyTrustLocalesQuery, FindManyTrustLocalesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindManyTrustLocalesQuery, FindManyTrustLocalesQueryVariables>(FindManyTrustLocalesDocument, options);
        }
export type FindManyTrustLocalesQueryHookResult = ReturnType<typeof useFindManyTrustLocalesQuery>;
export type FindManyTrustLocalesLazyQueryHookResult = ReturnType<typeof useFindManyTrustLocalesLazyQuery>;
export type FindManyTrustLocalesSuspenseQueryHookResult = ReturnType<typeof useFindManyTrustLocalesSuspenseQuery>;
export type FindManyTrustLocalesQueryResult = Apollo.QueryResult<FindManyTrustLocalesQuery, FindManyTrustLocalesQueryVariables>;